import { ArrowRight } from "lucide-react";

interface AgentSwitchMarkerProps {
  // Resolved display names of the handing-off and taking-over agents. Either may
  // be undefined when a name can't be resolved (legacy/agentless turns); the
  // marker then falls back to a generic label.
  fromAgent?: string;
  toAgent?: string;
}

// A divider rendered in the thread at the point the active agent changed. It
// belongs to neither turn: the per-turn label says who *answered*, this says
// where the hand-off *happened*. Without it a switch reads as the new agent's
// own turn, since each turn's avatar already shows its current agent.
export const AgentSwitchMarker = ({ fromAgent, toAgent }: AgentSwitchMarkerProps) => (
  <li className="flex items-center gap-3 py-2" aria-label="Agent switched">
    <span className="h-px flex-1 bg-border" aria-hidden />
    <span className="flex items-center gap-1.5 text-xs text-muted-foreground">
      {fromAgent && toAgent ? (
        <>
          <span>{fromAgent}</span>
          <ArrowRight className="size-3" aria-hidden />
          <span className="font-medium text-foreground">{toAgent}</span>
        </>
      ) : (
        <span>Switched agents</span>
      )}
    </span>
    <span className="h-px flex-1 bg-border" aria-hidden />
  </li>
);
